import React, { FC, useEffect } from 'react';
import { Col, Row } from 'antd';
import ScopeThreeCategoryCard from 'shared/components/ScopeThreeCategoryCard';
import { ReactComponent as CategoryOne } from 'assets/icons/box_cat1.svg';
import { ReactComponent as CategoryTwo } from 'assets/icons/settings_cat_2.svg';
import { ReactComponent as CategoryThree } from 'assets/icons/local_gas_station_cat_3.svg';
import { ReactComponent as CategoryFour } from 'assets/icons/local_shipping_cat_4.svg';
import { ReactComponent as CategoryFive } from 'assets/icons/waste_cat_5.svg';
import { ReactComponent as CategorySix } from 'assets/icons/flight_takeoff_cat_6.svg';
import { ReactComponent as CategorySeven } from 'assets/icons/directions_car_category_7.svg';
import { ReactComponent as CategoryEight } from 'assets/icons/apartment_category_8.svg';
import styles from './scopeUpstreamList.module.scss';
import { processingFacility } from 'constants/constants';
import { AppRoutes } from 'routes/routeConstants/appRoutes';
import ScopeThreeService from 'services/ScopeThreeService/scopeThree.service';
import useFilters from 'shared/hooks/useFilters';
import { queryParamsList } from '..';
import { useParams } from 'react-router-dom';
import LoaderAnimation from 'shared/components/LoaderAnimation';

interface CategoryProps {
  locationCategory?: string;
}

const ScopeThreeUpStreamList: FC<CategoryProps> = ({ locationCategory }) => {
  const { getParams } = useFilters();
  const { activeTab } = getParams(queryParamsList);
  const { id: locationId } = useParams();
  const { loading, fetchCategories, scopeThreeCategories } =
    ScopeThreeService();
  useEffect(() => {
    fetchCategories(Number(locationId), activeTab);
  }, []);

  const categoriesList = [
    {
      label: 'category_1',
      icon: <CategoryOne />,
      name: 'Category 1',
      title: 'Purchased Goods And Services',
      subHeading:
        'Emissions from the production of goods and services acquired by the company.',
      redirectionRoute: AppRoutes.SCOPE_3_CATEGORY_1, // Will change while integration
    },
    {
      label: 'category_4',
      icon: <CategoryFour />,
      name: 'Category 4 & 9',
      title: 'Upstream And Downstream Transportation And Distribution',
      subHeading:
        'Emissions from the transportation and distribution of Purchased goods and Finished goods',
      redirectionRoute: AppRoutes.CATEGORY_4,
    },
    {
      label: 'category_5',
      icon: <CategoryFive />,
      name: 'Category 5',
      title: 'Waste Generated In Operations',
      subHeading:
        'Emissions from waste disposal and treatment activities resulting from company operations.',
      redirectionRoute: AppRoutes.CATEGORY_5,
    },
    {
      label: 'category_2',
      icon: <CategoryTwo />,
      name: 'Category 2',
      title: 'Capital Goods',
      subHeading:
        'Emissions from the production of capital assets such as equipment, buildings, and machinery.',
      redirectionRoute: AppRoutes.CATEGORY_2,
    },
    {
      label: 'category_3',
      icon: <CategoryThree />,
      name: 'Category 3',
      title: 'Fuel And Energy Related Activities',
      subHeading:
        'Emissions from the upstream production and transportation of fuels and energy purchased by the company',
      redirectionRoute: AppRoutes.CATEGORY_3,
    },
    {
      label: 'category_6',
      icon: <CategorySix />,
      name: 'Category 6',
      title: 'Business Travel',
      subHeading:
        'Emissions from employee travel for business purposes via air, rail, road, or other modes in vehicles not owned by the company.',
      redirectionRoute: AppRoutes.CATEGORY_6,
    },
    {
      label: 'category_7',
      icon: <CategorySeven />,
      name: 'Category 7',
      title: 'Employee Commuting',
      subHeading:
        'Emissions from employees traveling to and from work. Remote working of employees can be captured here',
      redirectionRoute: AppRoutes.CATEGORY_7,
    },
    {
      label: 'category_8',
      icon: <CategoryEight />,
      name: 'Category 8',
      title: 'Upstream Leased Assets',
      subHeading:
        'Emissions from the operation of leased assets not included in Scope 1 and 2',
      redirectionRoute: AppRoutes.CATEGORY_8,
    },
  ];

  const updateCategoriesStatus = categoriesList.map(category => {
    const matchedStatus = scopeThreeCategories.find(
      status => status.label === category.label
    );
    return {
      ...category,
      status: matchedStatus ? matchedStatus.status : undefined,
    };
  });
  return (
    <div className={styles.upstreamContainer}>
      {loading ? (
        <div className={styles.loaderAnimation}>
          <LoaderAnimation />
        </div>
      ) : (
        <Row gutter={[24, 24]}>
          {updateCategoriesStatus.map(categories => {
            const { icon, name, title, subHeading, status, redirectionRoute } =
              categories;
            return (
              <Col span={8} key={name}>
                <ScopeThreeCategoryCard
                  icon={icon}
                  name={name}
                  title={title}
                  subHeading={subHeading}
                  status={status}
                  redirectRoute={redirectionRoute}
                  isProcessingFacility={locationCategory !== processingFacility}
                />
              </Col>
            );
          })}
        </Row>
      )}
    </div>
  );
};

export default ScopeThreeUpStreamList;